/**
 * Color constants for Charges Management
 * These match the theme palette values but can be used in non-theme contexts
 *
 * IMPORTANT: When using within MUI components with `sx` prop,
 * prefer using theme.palette.charges instead of these constants
 */

export const ChargesColors = {
  // Status colors
  STATUS_ACTIVE: "#4CAF50",
  STATUS_INACTIVE: "#9e9e9e",
  STATUS_WARNING: "#F44336",

  // Background colors
  BACKGROUND_LIGHT: "#f5f5f5",
  BACKGROUND_LIGHTER: "#f5f5f7",
  BACKGROUND_PANEL: "#f0f0f0",

  // Border colors
  BORDER_LIGHT: "#e8e8e8",
  BORDER_MEDIUM: "#e0e0e0",
  BORDER_DARK: "#ccc",

  // Charge type colors
  CHARGE_CLOSED: "#A52A2A",
  CHARGE_MANUAL: "#C96442",

  // Chart colors (Actual vs Recipe comparison)
  CHART_MANUAL_BADGE: "#ff9800",
  CHART_COMMODITY_FALLBACK: "#1890ff",
  CHART_LABEL_TEXT: "#ffffff",
  CHART_AXIS_SUBTITLE: "#a3a3a3",
} as const;
